import { useState, useEffect, useCallback } from 'react';

import { screeningRepository } from '../repositories/ScreeningRepository';
import { ScreeningSetup } from '../types/screening';

export interface UseScreeningSetupResult {
  screeningSetup: ScreeningSetup | null;
  isLoading: boolean;
  error: string | null;
  hasScreeningSetup: boolean;
  refresh: () => Promise<void>;
}

export const useScreeningSetup = (
  listingId: string
): UseScreeningSetupResult => {
  const [screeningSetup, setScreeningSetup] = useState<ScreeningSetup | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchScreeningSetup = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await screeningRepository.getScreeningSetup(listingId);
      setScreeningSetup(response.screeningSetup);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  }, [listingId]);

  const refresh = useCallback(async () => {
    await fetchScreeningSetup();
  }, [fetchScreeningSetup]);

  useEffect(() => {
    if (listingId) {
      fetchScreeningSetup();
    }
  }, [listingId, fetchScreeningSetup]);

  return {
    screeningSetup,
    isLoading,
    error,
    hasScreeningSetup: screeningSetup?.isSetup || false,
    refresh,
  };
};
